<template>
    <div class="header">
        <div class="col p-1 flex align-center">
            <div class="title-h1 p-2 mr-2 text-center">
                <i class="fal" :class="icon"></i>
            </div>
            <slot name="col-1"></slot>
        </div>
        <div class="col-4 p-1 mr-a ml-a text-center">
            <slot name="col-2"></slot>
        </div>
        <div class="col p-1">
            <slot name="col-3"></slot>
        </div>
    </div>
</template>

<script>
export default {
    name: "Structure_Header_Col3",
    props:{
        icon:String,
    }
}
</script>